import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

function resolvePublicAssetBase() {
  const base = (typeof process !== 'undefined' && process.env.BASE_URL) ? process.env.BASE_URL : '/'
  return base.endsWith('/') ? base : `${base}/`
}

/** 中文等 CID 字体依赖 CMap；电子发票缺此配置会只显示图章/税号、名称金额空白 */
function resolvePdfjsAssetOptions() {
  const root = `${resolvePublicAssetBase()}pdfjs/`
  return {
    cMapUrl: `${root}cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${root}standard_fonts/`
  }
}

function resolveOutputScale() {
  const dpr = typeof window !== 'undefined' ? (window.devicePixelRatio || 1) : 1
  // 略提高渲染密度，避免大屏/缩放后发糊
  return Math.min(Math.max(dpr, 1) * 1.25, 3)
}

/**
 * 将 PDF ArrayBuffer 渲染到容器内多个 canvas（按容器宽度 + 设备像素比清晰绘制）。
 * @returns {Promise<{ destroy: () => void }>}
 */
export async function renderPdfToContainer(arrayBuffer, container, options = {}) {
  if (!container) {
    throw new Error('预览容器不存在')
  }
  container.innerHTML = ''

  const loadingTask = pdfjsLib.getDocument({
    data: arrayBuffer,
    ...resolvePdfjsAssetOptions(),
    ...(options.documentOptions || {})
  })
  const pdf = await loadingTask.promise
  const pageCount = pdf.numPages
  const outputScale = options.outputScale || resolveOutputScale()
  const padding = 24
  const cssWidth = Math.max((container.clientWidth || container.parentElement?.clientWidth || 800) - padding, 360)

  for (let pageNum = 1; pageNum <= pageCount; pageNum += 1) {
    // eslint-disable-next-line no-await-in-loop
    const page = await pdf.getPage(pageNum)
    const baseViewport = page.getViewport({ scale: 1 })
    // 按容器宽度适配，避免 width:100% 拉伸低分 canvas
    const fitScale = cssWidth / baseViewport.width
    const scale = options.scale || fitScale
    const viewport = page.getViewport({ scale })

    const canvas = document.createElement('canvas')
    canvas.className = 'process-guide-pdf-page'
    canvas.width = Math.floor(viewport.width * outputScale)
    canvas.height = Math.floor(viewport.height * outputScale)
    canvas.style.display = 'block'
    canvas.style.width = `${Math.floor(viewport.width)}px`
    canvas.style.height = `${Math.floor(viewport.height)}px`
    canvas.style.maxWidth = '100%'
    canvas.style.margin = '0 auto 12px'
    canvas.style.background = '#fff'
    canvas.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)'
    container.appendChild(canvas)

    const ctx = canvas.getContext('2d', { alpha: false })
    const transform = outputScale !== 1
      ? [outputScale, 0, 0, outputScale, 0, 0]
      : null
    // eslint-disable-next-line no-await-in-loop
    await page.render({
      canvasContext: ctx,
      viewport,
      transform
    }).promise
  }

  return {
    destroy() {
      try {
        pdf.destroy()
      } catch (e) {
        // ignore
      }
      if (container) container.innerHTML = ''
    }
  }
}
